import * as React from 'react'; 
import { isImageLoading } from '../../../actions/miscellaneousActions';
import { compressBase64Image, getBase64 } from '../../../utils/generalUtils';
import { Async } from '../Async'; 
declare var require: any;
// const errorImage = require('../../../images/errorImage.png');
const loaderImage = require('./imgLoader.gif');

export interface IImgProps {
    className?: string;
    src: string;
    width?: string;
    height?: string;
    style?: React.CSSProperties;
    onClick?: (imageURL: string) => void;
}

export interface IImgState {
    imageSrc: string;
}

export class Img extends React.PureComponent<IImgProps, IImgState> {
    constructor(props) {
        super(props);
        this.state = { imageSrc: '' };
    }

    promise = async () => {
        const imgData = await getBase64(this.props.src);
        const imageBase64 = 'data:image/png;base64,' + imgData;
        compressBase64Image(imageBase64, (compressedImage) => {
            isImageLoading(false);
            this.setState({
                imageSrc: compressedImage
            });
        });
        return null;
    }

    render() {
        const { props: { className, height, width, src, style }, state: { imageSrc } } = this;
        return <Async
            identifier="IMG"
            promise={this.promise}
            error={<img
                width={width}
                height={height}
                style={{ boxShadow: 'none', pointerEvents: 'none' }}
                src={'errorImage'}
            />}
            loader={
                <div
                    // onClick={() => this.props.onClick(src)}
                    className="display-image-wrapper"
                >
                    <img width={width} style={style} height={height} className={className} src={loaderImage} />
                </div>}
            content={
                <div
                    onClick={() => this.props.onClick(src)}
                    className="display-image-wrapper"
                >
                    <img width={width} style={style} height={height} className={className} src={imageSrc} />
                </div>
            }
        />;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ImageGallery/Img.tsx